import React from 'react';
import '../App.css';
import MainSection from "../components/MainSection/MainSection";
import Cards from "../components/Cards/Cards";

function Home () {
    return (
        <>
            <MainSection />
            <Cards />
        </>
    )
}

export default Home;